jQuery(document).ready(function ($) {
    var module_name = 'gallery';

    $('.module.' + module_name.replace(/_/g, '-') + '-module').each(function (index) {
        let arrows = $(this).find('.arrow');
        let prevArrow = arrows.filter('.arrow-prev');
        let nextArrow = arrows.filter('.arrow-next');
        let box = $(this).find('.hs__wrapper');
        let width = $(window).width();

        let gallery_container = $('.gallery__images__container__image');
        let gallery_container_images = $('.gallery__images__container__image img');
        let gallery_image = $('.gallery__main-image img');

        prevArrow.fadeOut();

        if (box.length > 0 && width >= 992) {
            let x = 0;
            let mx = 0;
            let maxScrollWidth = box[0].scrollWidth - (box[0].clientWidth / 2) - (box.width() / 2);
            $(arrows).on('click', function () {
                if ($(this).hasClass('arrow-next')) {
                    $(this).fadeOut();

                    x = ((box.width() / 2)) + box.scrollLeft() + 8;

                    box.animate({
                        scrollLeft: x,
                    });
                } else {
                    $(this).fadeOut();
                    x = ((box.width() / 2)) - box.scrollLeft() + 8;

                    box.animate({
                        scrollLeft: -x,
                    });
                }
            });

            $(box).on({
                mousemove: function (e) {
                    var mx2 = e.pageX - this.offsetLeft;
                    if (mx) this.scrollLeft = this.sx + mx - mx2;
                },
                mousedown: function (e) {
                    this.sx = this.scrollLeft;
                    mx = e.pageX - this.offsetLeft;
                },
                scroll: function () {
                    toggleArrows();
                }
            });

            $(document).on('mouseup', function () {
                mx = 0;
            });

            function toggleArrows() {
                if (box.scrollLeft() > maxScrollWidth - 20) {
                    // disable next button when right end has reached
                    nextArrow.stop(true, true).fadeOut();
                } else if (box.scrollLeft() < 20) {
                    // disable prev button when left end has reached
                    prevArrow.stop(true, true).hide();
                } else {
                    // both are enabled
                    nextArrow.fadeIn();
                    prevArrow.fadeIn();
                }
            }
        }

        $(gallery_container_images).on('click', function() {
            $(gallery_container).find('img').removeClass('img--opacity');
            $(this).addClass('img--opacity');

            $(gallery_image).attr('src', $(this).attr('src'));
        });        
    });
});
